<template>
  <form>
  <fieldset class="mb-1">
    <legend>Location</legend>
    <div class="input-group input-group-sm mb-1">
      <div class="input-group-prepend">
        <span class="input-group-text">Location:</span>
      </div>
      <input type="text" class="form-control " v-model="address">
      <div class="input-group-append">
        <button class="btn btn-outline-primary" type="button" @click.prevent="onSearchAddress"><i class="fas fa-search"></i> Search</button>
        <button class="btn btn-outline-primary" type="button" @click.prevent="onLocate"><i class="fas fa-location-arrow"></i> Detect</button>
      </div>
    </div>
    <figure>
      <div class="map" ref="googlemap"></div>
      <figcaption v-if="position">
        <span class="badge badge-pill badge-secondary">Latitude:</span> {{ position.lat.toFixed(3) }}
        <span class="badge badge-pill badge-secondary">Longitute</span> {{ position.lng.toFixed(3) }}
      </figcaption>
    </figure>
  </fieldset>

  <fieldset>
    <legend>Prayer Times Setting</legend>
    <div class="form-group row mb-2">
      <label class="col-sm-3 col-form-label col-form-label-sm" for="prayerMethods">Adjust Hijri Date</label>
      <div class="col-sm-9">
        <input class="form-control form-control-sm" style="width:80px;" id="prayerMethods" type="number" v-model="settings.hijriCorrection">
        <div class="form-text text-muted"><small>Adjust Hijri date based on your local community. <br/>You can use <b>negative</b> or <b>positive</b> numbers.</small></div>
      </div>
    </div>

    <div class="form-group row mb-1">
    <label class="col-sm-3 col-form-label col-form-label-sm" for="prayerMethods">Method</label>
    <div class="col-sm-9">
      <select class="form-control form-control-sm" id="prayerMethods" v-model="settings.method">
        <option v-for="(key, val) in prayerMethods" :key="key" :value="val">{{ key }}</option>
      </select>
    </div>
    </div>

    <div class="form-group row">
      <label class="col-sm-3 col-form-label col-form-label-sm">Asr Method</label>

      <div class="col-sm-9">
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" v-model="settings.asr" id="asr-hanafi" value="Hanafi">
        <label class="form-check-label" for="asr-hanafi">Hanafi</label>
      </div>
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" v-model="settings.asr" id="asr-standard" value="Standard">
        <label class="form-check-label" for="asr-standard">Standard <small>(Shafi', Maliki, Hanbali)</small></label>
      </div>
      </div>
    </div>
  </fieldset>
  </form>
</template>

<script>
import Widget from "@/Widget";
import Modal from '@/Modal';
import moment from 'moment';
import hijri from "moment-hijri";


moment.locale('en');
export default {
  components: {
    Widget, Modal
  },

  computed: {
    position() {
      return this.$store.getters.location;
    },

    currentTime() {
      return this.$store.state.time;
    },

    prayerMethods() {
      return this.$store.state.prayerCalculatingMethods;
    },

    hijri() {
      return  hijri(this.currentTime).format("iMMMM iD iYYYY");
    },

    date() {
      return moment(this.currentTime).format('LL');
    },

    time() {
      return moment(this.currentTime).format('LTS')
    },
  },

  data() {
    return {
      title: null,
      address: null,
      settings: null,
      googleMap: null
    }
  },

  watch: {
    position(val) {
      console.log('position changed.', val);
      if(this.googleMap) {
        this.googleMap.setCenter(val);
      }
    }
  },

  created() {
    this.settings = this.$store.getters.settings;

    this.$watch('settings', (settings) => {
      this.$store.commit('settings', settings);
    }, {deep:true});
  },

  mounted() {
    if(!this.googleMap) {
        this.googleMap = new google.maps.Map(this.$refs.googlemap, {
          zoom: 10
        });
      }
      
      if(this.position) {
        this.googleMap.setCenter(this.position)
      }
  },

  methods: {
    onLocate() {
      this.$store.dispatch('locate');
    },

    onSearchAddress() {
      this.$store.dispatch('geocode', this.address);
    }
  }
};
</script>

<style lang="scss" scoped>

.map {
  width:100%;
  height: 100px;
}

legend {
  font-size: 1.1em;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/lib/ui/AppSettings.vue